<adapt-menu [items]="itemMenu"
            [showOnHover]="true"
            (visibleChanged)="visibilityChanged.emit($event)"></adapt-menu>
